export const TEST_IDS = {
  nav: {
    root: "site-nav",
    logo: "nav-logo",
    linkHome: "nav-link-home",
    linkDiamonds: "nav-link-diamonds",
    linkStones: "nav-link-stones",
    linkSourcing: "nav-link-sourcing",
    linkCertification: "nav-link-certification",
    linkContact: "nav-link-contact",
    // Legacy IDs kept so older tests still pass:
    linkAbout: "nav-link-home",
    linkExpertise: "nav-link-diamonds",
    linkCollection: "nav-link-stones",
    ctaInquiry: "nav-cta-inquiry",
  },
  hero: {
    root: "hero-section",
    heading: "hero-heading",
    sub: "hero-subheading",
    ctaInquiry: "hero-cta-inquiry",
    ctaCollection: "hero-cta-collection",
    scrollHint: "hero-scroll-hint",
    canvas: "hero-diamond-canvas",
    trustLine: "hero-trust-line",
  },
  about: {
    root: "about-section",
    heading: "about-heading",
  },
  diamonds: {
    root: "natural-diamonds-section",
    heading: "natural-diamonds-heading",
    card: (slug) => `natural-diamonds-card-${slug}`,
  },
  // Legacy alias for older tests
  expertise: {
    root: "natural-diamonds-section",
    card1: "natural-diamonds-card-white",
    card2: "natural-diamonds-card-colored",
    card3: "natural-diamonds-card-private",
  },
  sourcing: {
    root: "sourcing-section",
    heading: "sourcing-heading",
    canvas: "sourcing-diamond-canvas",
  },
  // Legacy alias
  transformation: {
    root: "sourcing-section",
    heading: "sourcing-heading",
    canvas: "sourcing-diamond-canvas",
  },
  stones: {
    root: "precious-stones-section",
    heading: "precious-stones-heading",
    card: (slug) => `precious-stones-card-${slug}`,
  },
  // Legacy alias
  collection: {
    root: "precious-stones-section",
    card: (slug) => `precious-stones-card-${slug}`,
  },
  certification: {
    root: "certification-section",
    heading: "certification-heading",
  },
  jewelry: {
    root: "jewelry-section",
    heading: "jewelry-heading",
  },
  why: {
    root: "why-section",
    heading: "why-heading",
  },
  inquiry: {
    root: "inquiry-section",
    form: "inquiry-form",
    name: "inquiry-input-name",
    email: "inquiry-input-email",
    phone: "inquiry-input-phone",
    type: "inquiry-select-type",
    message: "inquiry-textarea-message",
    submit: "inquiry-submit-button",
    success: "inquiry-success-message",
    error: "inquiry-error-message",
    honeypot: "inquiry-input-company",
  },
  footer: {
    root: "site-footer",
    instagram: "footer-link-instagram",
    facebook: "footer-link-facebook",
    linkedin: "footer-link-linkedin",
    email: "footer-link-email",
    privacy: "footer-link-privacy",
  },
};
